import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connectToStores } from 'fluxible-addons-react';
import { FormattedMessage } from 'react-intl';
import AccountMessages from './AccountMessages';
import FormState from '../../../constants/FormState';
import ResetPasswordForm from './ResetPasswordForm';

@connectToStores(['ResetPasswordStore'], (context) => {
  const ResetPasswordStore = context.getStore('ResetPasswordStore');

  return {
    formState: ResetPasswordStore.getFormState()
  };
})
class ResetPassword extends Component {

  static propTypes = {
    formState: PropTypes.string.isRequired
  };

  render() {
    const { formState } = this.props;

    const formComplete = formState === FormState.COMPLETED;

    const component = formComplete ?
      [] :
      <div className="card-body">
        <ResetPasswordForm />
      </div>;

    const resetMessage = formComplete ?
      AccountMessages.resetCompletePrompt :
      AccountMessages.resetPrompt;

    return <div className="login-container">
      <div className="card">
        <div className="card-body">
          <h2 className="card-title">
            <FormattedMessage { ...AccountMessages.resetHeader } />
          </h2>
          <h4 className="card-subtitle text-muted">
            <FormattedMessage { ...resetMessage } />
          </h4>
        </div>
        { component }
      </div>
    </div>;
  }
}

export default ResetPassword;



// WEBPACK FOOTER //
// ./src/apps/Account/components/ResetPassword.js